import userData from "./user-data";

export default {
  namespaced: true,
  modules: {
    userData
  }
};
